module.exports = __webpack_public_path__ + "img/grandma_squarepants.4cb6ced0.jpg";